import { PlayerEnvironment } from '../../player_environment';
import VideoJsAdapter from '../../adapters/videojs_adapter';
import Component from '../component.js';
import NextVideoService from '../../service/next_video/service';
import './next_video';

export default class Index extends Component {
  constructor(player, options = {}){
    super(player, options);
    this._gettingNextVideoData = false;
    this._endCreditTime = options.endCreditTime;
    this._hasShown = false;
    this._seeking = false;
    this._nextVideoInitialized = false;
  }

  duration() {
    return Math.floor(this.player().duration());
  }

  currentTime() {
    return Math.floor(this.player().currentTime());
  }

  timeShouldNextVideoPanelShow() {
    if (this._endCreditTime > 0 && this._endCreditTime < this.duration()) {
      return this._endCreditTime;
    }
    return this.duration();
  }

  ready(){
    this.player().on('timeupdate', this.onTimeUpdate.bind(this));
    this.player().on('nextvideo_close', this.hide.bind(this));
    this.player().on('ended', this.onEnded.bind(this));
    this.player().on('seeking', this.onSeeking.bind(this));
    this.player().on('seeked', this.onSeeked.bind(this));
  }

  createEl(){
    let el = super.createEl('div', {
      className: 'vjs-video-ended-panel vjs-video-ended-panel--hidden'
    });

    return el;
  }

  show(){
    if (NextVideoService.dataIsExists()) {
      if(!this._nextVideoInitialized){
        this.addChild('VpNextVideo', NextVideoService.data());
        this._nextVideoInitialized = true;
      }
      this._hasShown = true;
      this.removeClass('vjs-video-ended-panel--hidden');
      this.playerControlBar().hide();
      this.player().trigger('next_video_show');
      if (PlayerEnvironment.isMobileSite()) {
        this.player().el().querySelector('.vjs-big-pause-button').classList.add('hidden');
      }
    }
  }

  hide(){
    this.addClass('vjs-video-ended-panel--hidden');
    this.playerControlBar().show();
    if (PlayerEnvironment.isMobileSite()) {
      this.player().el().querySelector('.vjs-big-pause-button').classList.remove('hidden');
    }
  }

  playerControlBar() {
    return this.player().controlBar;
  }

  isInAdMode() {
    return this.player().ads?.isInAdMode?.();
  }

  onTimeUpdate() {
    if (this.isInAdMode() || this.duration() <= 0) return;
    if (this.shouldGetNextVideoData()) {
      this._gettingNextVideoData = true;

      NextVideoService.request(
        this.onGetNextVideoComplete.bind(this)
      );
    }

    if (this.shouldNextVideoShow()) {
      this.show();
    }
  }

  shouldGetNextVideoData() {
    if (this._gettingNextVideoData === true) return false;
    if (NextVideoService.dataIsExists()) return false;
    return (this.timeShouldNextVideoPanelShow() - this.currentTime()) <= 5;
  }

  shouldNextVideoShow() {
    return (this.currentTime() >= this.timeShouldNextVideoPanelShow() && !this._hasShown && !this._seeking);
  }

  onGetNextVideoComplete(isSuccess) {
    this._gettingNextVideoData = false;

    if (isSuccess && !this._nextVideoInitialized) {
      this.addChild('VpNextVideo', NextVideoService.data());
      this._nextVideoInitialized = true;
    } else {
      this.hide();
    }
  }

  onEnded() {
    this._hasShown = false;
  }

  onSeeking() {
    this._seeking = true;
  }

  onSeeked() {
    this._seeking = false;
  }
}

VideoJsAdapter.registerComponent('VpVideoEndedPanel', Index);
